<template>
  <div class="backgroud-white cs-score-detail" v-loading="loading">
    <div class="backgroud-gray-popup popup-content-area-small">
      <div class="cs-score-detail-item">
        <span class="cs-title">{{dataIn.courseName}}{{scoreTypeDesc}}</span>
      </div>
      <div class="cs-score-detail-item">
        <el-row>
          <el-col :span="7">名称</el-col>
          <el-col :span="7">班级均分</el-col>
          <el-col :span="7">{{scoreTypeText}}成绩</el-col>
        </el-row>
        <el-row v-for="(item, index) in scoreData.ScoreList" :key="index">
          <el-col :span="7">
            <elScsInput :isReadonly="isReadonly" :isInEditing="!!item.isEditing" :maxlength="200" v-model="item.Name" :inputType="inputType.string" placeholder="请输入名称"></elScsInput>
          </el-col>
          <el-col :span="7">
            <elScsInput :isReadonly="isReadonly" :isInEditing="!!item.isEditing" v-model="item.ClassAverageScore" :inputType="inputType.int" :isPercentage="true" placeholder="请输入班级均分"></elScsInput>
          </el-col>
          <el-col :span="7">
            <elScsInput :isReadonly="isReadonly" :isInEditing="!!item.isEditing" v-model="item.Score" :inputType="inputType.int" :isPercentage="true" placeholder="请输入成绩"></elScsInput>
          </el-col>
          <el-col :span="3">
            <el-button v-if="!isReadonly" size="small" type="text" icon="el-icon-delete cs-redLabel" class="button-delete" @click="onDelete(index)">删除</el-button>
          </el-col>
        </el-row>
        <el-button v-if="!isReadonly" type="text" @click="onAddScore" size="small"><i class="el-icon-plus"></i>添加新{{scoreTypeText}}</el-button>
      </div>
      <div class="cs-score-detail-item">
        <el-row>
          <el-col :span="summationItemSpan">
            <span>班级均分</span>
            <elScsInput :isReadonly="isReadonly" v-model="scoreData.SummationScore.ClassAverageScore" :inputType="inputType.int" :isPercentage="true" placeholder="请输入班级均分"></elScsInput>
          </el-col>
          <el-col :span="summationItemSpan">
            <span>课程成绩</span>
            <elScsInput :isReadonly="isReadonly" v-model="scoreData.SummationScore.Score" :inputType="inputType.int" :isPercentage="true" placeholder="请输入课程成绩"></elScsInput>
          </el-col>
          <el-col v-if="scoreType == 2" :span="summationItemSpan">
            <span>课程Letter Grade</span>
            <elScsInput :isReadonly="isReadonly" v-model="scoreData.SummationScore.LetterGradeScore" :isDropdown="true" :dropdownListData="universityScoreList" :inputType="inputType.string" placeholder="请输入课程Letter Grade"></elScsInput>
          </el-col>
          <el-col v-if="scoreType == 2" :span="summationItemSpan">
            <span>课程GPA</span>
            <elScsInput :isReadonly="isReadonly" v-model="scoreData.SummationScore.GPAScore" :min="0" :max="5" :inputType="inputType.decimal" placeholder="请输入课程GPA"></elScsInput>
          </el-col>
        </el-row>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer" v-if="!isReadonly">
      <el-row>
        <el-col :span="24" class="text-center">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="text-center" :span="24">
          <el-button type="primary" @click="onSave()">确认保存</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-score-detail {
  h6 {
    font-weight: bold;
  }
}
.button-delete{
  color:red;
}
</style>

<script>
import { getScoreData, saveScoreData } from "@/service/studyAbroad.service";
import elScsInput from "../../common/el-scs-input";
import {
  getScoreList
} from "@/service/common.service";

export default {
  props: {
    isReadonly: Boolean,
    dataIn: {
      studentId: Number,
      courseId: Number,
      courseName: String,
    },
    scoreType: {
      //1-学校作业, 2-学校成绩
      type: [Number, String],
      default: 1,
      validator: (value) => {
        let strValue = `${value}`;
        return ["1", "2"].contains(strValue);
      },
    },
  },
  data() {
    return {
      loading: false,
      showError: false,
      errorMessage: "",
      inputType:{},
      scoreTypeDesc: "",
      scoreTypeText: "",
      summationItemSpan: 6,
      universityScoreList:[],
      scoreData: {
        CourseId: 0,
        StudentId: 0,
        ScoreType: 0,
        ScoreList: [],
        SummationScore: {},
      },
    };
  },
  components: {
    elScsInput
  },
  created() {
    this.inputType = this.GLOBAL.inputType;
    this.getScoreTypeDesc();
    if (this.scoreType == 2){
      getScoreList().then(result =>{
        if (result && result.success){
          this.universityScoreList = result.data.filter(i => i.CourseType == 1).map(i => ({Key:i.Text, Value: i.Text}));
        }
      });
    }
    this.init();
  },
  methods: {
    init() {
      if (
        this.dataIn &&
        this.dataIn.studentId &&
        this.dataIn.courseId &&
        this.scoreType
      ) {
        this.loadData();
      }
    },
    loadData() {
      this.loading = true;
      getScoreData(
        this.dataIn.studentId,
        this.dataIn.courseId,
        this.scoreType
      ).then((result) => {
        if (result && result.success) {
          this.scoreData = result.data;
        }
        this.loading = false;
      });
    },
    getScoreTypeDesc() {
      if (this.scoreType == 1) {
        this.scoreTypeText = "作业";
        this.scoreTypeDesc = "学校作业详情";
      } else if (this.scoreType == 2) {
        this.scoreTypeText = "类目";
        this.scoreTypeDesc = "学校成绩详情";
      }
    },
    onAddScore(){
      let model = {
        Id: 0,
        Name: "",
        Score: 0,
        ClassAverageScore: 0,
        isEditing: true
      };
      this.scoreData.ScoreList.push(model);
    },
    onDelete(index) {
      this.$confirm(`您确定要删除该条${this.scoreTypeDesc}吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.scoreData.ScoreList.splice(index, 1);
        })
        .catch(() => {});
    },
    onSave() {
      this.loading = true;
      saveScoreData(this.scoreData).then(result => {
        if (result && result.success){
          this.$message.success("保存成功");
          this.$emit("saveSuccess");
        }else{
          this.showError = true;
          this.errorMessage = result.message;
        }
        this.loading = false;
      });
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/scoreDetail.vue